import { css } from 'lit';

export const homeOnboardViewStyles = css`
  
  :host {
    background: linear-gradient(0deg, var(--gray-1) 0%, var(--gray-1) 85%, var(--teal-2) 100%);
  }

  content-container {
    display: flex;
    gap: var(--view-item-spacing);
    flex-wrap: wrap;
  }

  tutorial-panel {
    display: block;
    flex: 1 1 40%;
    min-width: 18rem;
  }
  
  profile-panel {
    display: block;
    flex: 1 1 40%;
    min-width: 18rem;
  }

  h1, h2, h3 {
    line-height: 1.3em;
  }
  h1 .prefix {
    display: block;
    font-weight: 100;
  }

  q1-tutorial-list {
    margin: var(--view-item-spacing) 0;
    padding: 0.5rem;

    background: white;
    border-radius: 7px;
    box-shadow: var(--sl-shadow-x-small);
  }

  button-bar {
    justify-content: flex-end;
  }

`;
